import { Button, Modal } from "react-bootstrap";
import React, { useCallback, useEffect, useState } from "react";
import BaseSelect from "react-select";
import FixRequiredSelect from "../../components/sis/modalcliente/FixRequiredSelect";
import { getAllUsuario } from "../../../api/usuarioApi";
import Swal from "sweetalert2";

const options = [
  { value: 1, label: "1 - One" },
  { value: 2, label: "2 - Two" },
  { value: 3, label: "3 - Three" },
];

const Select = (props) => (
  <FixRequiredSelect
    {...props}
    SelectComponent={BaseSelect}
    options={props.options || options}
  />
);

// Formatea número con puntos de miles, preservando signo negativo inicial
const addCommas = (num) => {
  if (num === null || num === undefined) return "0";
  let str = num.toString();
  const isNegative = str.startsWith("-");
  // Si el usuario solo escribió "-" todavía
  if (isNegative && str === "-") return "-";
  // Quitar todo excepto dígitos
  const digits = str.replace(/[^0-9]/g, "");
  if (!digits) return isNegative ? "-0" : "0";
  const withDots = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return isNegative ? `-${withDots}` : withDots;
};

// Normaliza: conserva solo un posible "-" al inicio y luego dígitos
const normalizeSignedIntString = (val) => {
  let s = (val ?? "").toString().trim();
  const isNegative = s.startsWith("-");
  // quitar todo excepto dígitos
  s = s.replace(/[^0-9]/g, "");
  return isNegative ? "-" + s : s;
};

const ModalEditGastos = (props) => {
  const { estado, onCloseModal, onReturnValue, rowdata } = props;
  
  const [listUsuarios, setListUsuario] = useState([]);

  // Estado de monto formateado (string con puntos y posible "-")
  const [monto, setMonto] = useState(
    addCommas(
      rowdata?.monto !== undefined && rowdata?.monto !== null
        ? rowdata.monto
        : 0
    )
  );

  // Estado principal del formulario
  const [formData3, setValue] = useState({
    ...rowdata,
    factura: rowdata?.factura || "",
  });

  const handleMontoChange = (event) => {
    const raw = event.target.value;

    // Permitir que el usuario empiece tecleando solo "-"
    if (raw === "-") {
      setMonto("-");
      return;
    }

    // Normalizamos a un entero con posible "-"
    const normalized = normalizeSignedIntString(raw);

    // Formateamos con separadores
    setMonto(addCommas(normalized));
  };

  const assigmentValue = useCallback(async () => {
    const resultUsuario = await getAllUsuario();
    const filterNumbers = resultUsuario.filter(
      (num) => num.estaActivo !== "Inactivo"
    );
    const resultMapeado = filterNumbers.map((item) => ({
      label: item.Usuario,
      value: item.IdUsuario,
    }));
    const newList = [{ label: "Otros", value: 0 }, ...resultMapeado];
    setListUsuario(newList);
  }, []);

  useEffect(() => {
    assigmentValue();
  }, [assigmentValue]);

  const handleSubmit2 = (event) => {
    event.preventDefault();

    formData3.paraTarifa = formData3.paraTarifa ? formData3.paraTarifa : "SI";
    formData3.paraHonorario = formData3.paraHonorario
      ? formData3.paraHonorario
      : "SI";

    // Convertir el string mostrado (con puntos y posible "-") a número entero
    let raw = monto;
    if (raw === "-" || raw.trim() === "") {
      formData3.monto = 0;
    } else {
      // Quitamos puntos y mantenemos signo
      const negative = raw.startsWith("-");
      const digits = raw.replace(/[^0-9]/g, "");
      formData3.monto = digits ? parseInt((negative ? "-" : "") + digits, 10) : 0;
    }

    formData3.factura = formData3.factura ? formData3.factura.trim() : "";

    // Validaciones
    if (formData3.idUsuario === undefined) {
      Swal.fire({
        title: "Seleccione Profesional",
        icon: "error",
      });
      return;
    }
    if (!formData3.gasto || formData3.gasto.trim() === "") {
      Swal.fire({
        title: "Ingrese nombre del gasto",
        icon: "error",
      });
      return;
    }

    // Si deseas permitir 0 o no:
    if (formData3.monto === 0) {
      Swal.fire({
        title: "Monto Incorrecto (no puede ser 0)",
        icon: "error",
      });
      return;
    }

    // Si quieres prohibir solo positivos o solo negativos, podrías añadir reglas aquí.
    // Ejemplo (opcional): si no quieres permitir negativos, descomenta:
    // if (formData3.monto < 0) {
    //   Swal.fire({ title: "No se permiten montos negativos", icon: "error" });
    //   return;
    // }

    if (!formData3.fecha) {
      Swal.fire({
        title: "Seleccione una fecha",
        icon: "error",
      });
      return;
    }

    onReturnValue(formData3);
  };

  return (
    <Modal show={estado} onHide={onCloseModal} size="m">
      <Modal.Header closeButton>
        <Modal.Title>Editar Gastos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="form-group mb-2 row">
            <label className="col-form-label">
              Profesional <span className="text-danger">*</span>
            </label>
            <Select
              options={listUsuarios}
              isSearchable
              defaultValue={{
                label: formData3.usuario,
                value: formData3.idUsuario,
              }}
              onChange={(e) => {
                setValue({
                  ...formData3,
                  idUsuario: e.value,
                  usuario: e.label,
                });
              }}
            />
          </div>

          <div className="form-group mb-2 col">
            <label className="col-form-label">Factura</label>
            <input
              type="text"
              className="form-control"
              placeholder="Número / código de factura"
              maxLength={50}
              value={formData3.factura}
              onChange={(e) =>
                setValue({
                  ...formData3,
                  factura: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group mb-2 col">
            <label className="col-form-label">
              Detalle <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              value={formData3.gasto}
              rows={7}
              onChange={(e) => {
                setValue({
                  ...formData3,
                  gasto: e.target.value,
                });
              }}
            />
          </div>

            <div className="form-group mb-2 col">
              <label className="col-form-label">
                Monto (puede ser negativo) <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                value={monto}
                onInput={handleMontoChange}
                className="form-control"
                inputMode="numeric"
                // pattern opcional si quieres restringir en móviles:
                // pattern="-?[0-9.]*"
                placeholder="Ej: -12.500"
              />
            </div>

          <div className="form-group mb-2 col">
            <label className="col-form-label">
              Fecha <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              value={formData3.fecha || ""}
              required
              onChange={(e) => {
                setValue({
                  ...formData3,
                  fecha: e.target.value,
                });
              }}
            />
          </div>

          <div className="form-group mb-2 row">
            <div className="col">
              <label className="col-form-label">Para Tarifa?</label>
              <select
                name="paraTarifa"
                className="form-control"
                value={formData3.paraTarifa}
                onChange={(e) => {
                  setValue({
                    ...formData3,
                    [e.target.name]: e.target.value,
                  });
                }}
              >
                <option value="SI">Si</option>
                <option value="NO">No</option>
              </select>
            </div>
            <div className="col">
              <label className="col-form-label">Para Honorario?</label>
              <select
                name="paraHonorario"
                className="form-control"
                value={formData3.paraHonorario}
                onChange={(e) => {
                  setValue({
                    ...formData3,
                    [e.target.name]: e.target.value,
                  });
                }}
              >
                <option value="SI">Si</option>
                <option value="NO">No</option>
              </select>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cerrar
        </Button>
        <Button onClick={handleSubmit2} form="userform">
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEditGastos;